<template>
  <v-container>
    <v-alert v-if="success" type="success"
      >Your email was successfully verified. Click
      <router-link to="/">here</router-link> to return to the homepage.</v-alert
    >
    <v-alert v-if="error" type="error"
      >Verification was not successful. Your request has expired or your email
      is already verified. If your email is still not verified, please request
      another email from the
      <router-link to="/application-status">application status</router-link>
      page</v-alert
    >
  </v-container>
</template>

<script>
import firebase from "@/firebase";
const auth = firebase.auth();

export default {
  data: () => ({
    success: false,
    error: false
  }),
  async created() {
    const actionCode = this.$route.query.oobCode;

    try {
      await auth.applyActionCode(actionCode);
      this.success = true;
    } catch (e) {
      this.error = true;
    }
  }
};
</script>
